import { useMutation } from "@tanstack/react-query";
import { EDIT_GOAL } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { ApiResponseData } from "api/types";
import { IReturnType } from "hooks/types";
import { SnackbarSeverity } from "hooks/useSnackbar";
import IGoal from "models/Goal";
import { FieldValues } from "react-hook-form";

type Props = {
  callback?: () => void;
  id: string;
  showSnackbar?: (message: string, severity: SnackbarSeverity) => void;
};

const useEditGoalMutation = ({ callback, id, showSnackbar }: Props) => {
  const {
    data: response,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
    mutate,
  }: IReturnType<ApiResponseData<IGoal>> = useMutation(
    [EDIT_GOAL],
    ({ payload }: { payload: FieldValues }) => fetchApi(`kpis`).put(`/${id}`, payload),
    {
      onSuccess: (data) => {
        showSnackbar && showSnackbar("Goal Updated Successfully", "success");
        callback && callback();
      },
      onError: (error) => {
        showSnackbar("Failed to Update Goal", "error");
      },
    }
  );
  return { data: response?.data, isLoading, isError, isFetching, isSuccess, mutate, refetch };
};

export default useEditGoalMutation;
